var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-wrap",class:{ 'no-scroll' : !_vm.scrollable }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }